// src/shared/tableConfig.ts
// rowsPerPageOptions={DEFAULT_ROWS_PER_PAGE_OPTIONS}
export const DEFAULT_ROWS_PER_PAGE_OPTIONS = [10, 25, 50, 100, 250, 500] as const;
